import { CustomFieldModel } from './case-field.model';

export enum FormIsDeleted {
  Normal = 0,
  Deleted = 1,
}

export enum FormStatusEnum {
  Inactive = '0',
  Active = '1',
}

export enum Scene {
  EditAllForm = 1,
  Archive = 2,
  Default = 3,
}

export class CustomFormModel {
  brand_alls?: Brand[];

  brand_ids: string[] = [];

  description = '';

  field_lists: CustomFieldModel[] = [];

  field_list_alls?: CustomFieldModel[];

  name = '';

  id = '';

  is_default: boolean = false;

  is_deleted = FormIsDeleted.Normal;

  is_edit_contact: boolean = false;

  readonly is_system: boolean = false;

  shown_contact = '';

  status = FormStatusEnum.Active;

  scene = Scene.EditAllForm;

  create_by = '';

  create_by_name = '';
}

interface Brand {
  id: string;

  name: string;
}

export type CustomFormType = Partial<CustomFormModel>;

export class CaseFormModel {
  id = '';
  name = '';
  shown_contact = '';
  status = FormStatusEnum.Active;
  field_lists: CustomFieldModel[] = [];
  is_default = false;
  is_deleted = FormIsDeleted.Normal;
  is_edit_contact = false;
  create_by = '';
}
